import { useEffect } from "react";
import Lenis from "lenis";

export const scrollToId = (hash) => {
    const el = document.querySelector(hash);
    if (!el) return;
    if (window.__lenis) {
        window.__lenis.scrollTo(el, { offset: -72, duration: 1.2 });
    } else {
        el.scrollIntoView({ behavior: "smooth" });
    }
};

export default function SmoothScroll({ children }) {
    useEffect(() => {
        // native scrolling on touch devices — Lenis momentum only for desktop pointers
        const isTouch =
            window.matchMedia("(pointer: coarse)").matches ||
            window.matchMedia("(max-width: 768px)").matches ||
            "ontouchstart" in window;
        if (isTouch) return;

        const lenis = new Lenis({ lerp: 0.09 });
        window.__lenis = lenis;
        let raf;
        const loop = (t) => {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);
    return children;
}
